
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[slug]/live",
      function () {
        return require("private-next-pages/events/[slug]/live.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[slug]/live"])
      });
    }
  